import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Modal from '../../../common/modal'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../common/modaltypes'
import { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { navigation3 } from '../../../common/helper'
import { cargoServiceTypes, standardRatehistoryHeader } from './rateMatrixConstants'
import { useTranslation } from '../../../../i18n/I18nProvider'

const StandardRateMatrixHistory = ({ data, methods }) => {
  const theme = useTheme()
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const t = (key, fallback) => gs?.[key] || fallback
  const cargoServiceTypeOptions = cargoServiceTypes.map((item) => ({ ...item, name: t(item.translationKey, item.name) }))
  const translatedStandardRatehistoryHeader = standardRatehistoryHeader.map((col) => ({ ...col, headerName: t(col.translationKey, col.headerName) }))
  const [selectedServiceType, setSelectedServiceType] = useState({})
  const { loginData, headText, listData = []} = data

  const { updateModal } = methods
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  return (
    <Modal
      headTxt={headText || t('uploadFile', 'Upload File')}
      width={'95%'}
      updateModal={updateModal}
      height={listData.length > 15 ? '80%' : undefined}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <div style={{ position: 'relative', height: 'calc(100% - 53px)' }}>
        <Grid container sx={{ display: 'flex', gap: '16px', padding: '12px 15px 4px 15px' }}>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={'Cargo_Service_Type'}
              label={t('cargoServiceType', 'Cargo Service Type')}
              data={cargoServiceTypeOptions}
              defaultvalue={cargoServiceTypeOptions[0].name}
              onSelect={(seviceType) => {
                setSelectedServiceType(seviceType)
              }}
              idKey={`id`}
              dataKey={`name`}
              width={'100%'}
              nextId={``}
              prevId={``}
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA label={t('multiCargoServiceType', 'Multi Cargo Service Type')} idKey={`id`} dataKey={`name`} nextId={``} prevId={``} width={'100%'} />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA label={t('consignmentType', 'Consignment Type')} idKey={`id`} dataKey={`name`} nextId={``} prevId={``} width={'100%'} />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => {})}
              id={'search_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
            >
              {t('load', 'Load')}
            </Button>
          </Item>
        </Grid>
        <Grid container sx={{ paddingX: '15px', marginBottom: '10px', height: 'calc(100% - 120px)' }}>
          <TableContainer component={Paper} className="scroll" sx={{ marginY: '5px', height: '100%' }}>
            <Table
              stickyHeader
              size="small"
              aria-label="a dense table"
              sx={{
                '& .MuiTableCell-root': {
                  padding: '6px 4px !important',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  {translatedStandardRatehistoryHeader.map((row, index) => {
                    return (
                      <TableCell
                        key={`TH-${index}`}
                        sx={{
                          ...row.headerSx,
                          backgroundColor: '#DAEDFE',
                          height: '30px',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#444',
                          fontSize: '12px',
                        }}
                      >
                        {row.headerName}
                      </TableCell>
                    )
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {listData.map((item, index) => (
                  <TableRow key={`DR-${index}`}>
                    {translatedStandardRatehistoryHeader.map((col) => (
                      <TableCell key={col.field} sx={{ ...col.headerSx, height: '29px', fontSize: '12px', fontWeight: '400' }}>{item[col.field]}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid container sx={{ display: 'flex', gap: '16px', padding: '5px 15px 15px 15px', justifyContent: 'flex-end' }}>
          <Item sx={{ ...sx.itemsx }} className="">
            <Button
              variant="outlined"
              id={'add_btn'}
              color="secondary"
              sx={{ width: '100%', fontSize: '16px' }}
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.PickupAndDropoffModal)
              }}
            >
              {t('exportAsExcel', 'EXPORT AS EXCEL')}
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="">
            <Button
              variant="contained"
              id={'add_btn'}
              color="secondary"
              sx={{ width: '100%', fontSize: '16px' }}
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.PickupAndDropoffModal)
              }}
            >
              {t('print', 'PRINT')}
            </Button>
          </Item>
        </Grid>
      </div>
    </Modal>
  )
}
export default StandardRateMatrixHistory
